import { render } from "./Steps.vue?vue&type=template&id=a32c9ea2"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=a32c9ea2&lang=scss"
script.render = render

export default script